import React from 'react';
import Steps from './steps/index';
import './style.scss';

const App = () => {

	return (
		<div className="starter-templates-ai-steps">
			<Steps />
		</div>
	)
}

export default App;
